import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class StripePersonPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.stripePersonRead,
    );
    this.stripePersonAutocomplete = permissionChecker.match(
      Permissions.values.stripePersonAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.stripePersonCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.stripePersonEdit,
    );
  }
}
